import React, { useState, useEffect, useRef, useDidShow } from "react";
import "./index.less";
import { Button, Image, message, Modal, Pagination, Tabs } from 'antd';
import { request } from "@/utils/request"
import Config from "@/config/config";
import { formatTimestampToDate, getCountdownMinutesSeconds } from "@/utils/func";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { APPOINTMENT_STATUS, APPOINTMENT_STATUS_NAME, ORDER_STATUS, ORDER_STATUS_NAME, PAYMENT_STATUS, REFOUND_AMOUNT_STATUS, REFOUND_AMOUNT_STATUS_NAME, REFOUND_DEPOSIT_STATUS, REFOUND_DEPOSIT_STATUS_NAME } from "@/constant";
import { useLocation, useNavigate } from "react-router-dom";

export default function OrderDetail() {
    const navigate = useNavigate();
    const [info, setInfo] = useState()
    const [orderDetail, setOrderDetail] = useState({});
    const timeRef = useRef(null)
    const [time, setTime] = useState('')
    const queryParams = new URLSearchParams(window.location.search);
    const [openCertificate, setOpenCertificate] = useState(false)
    const getRestaurantDetail = (id) => {
        request.get(`restaurant/detail?id=${id}`).then(r => {
            setInfo(r.data);
        })

    }
    const getOrderDetail = () => {
        request.get(`restaurant/reservation_order_detail?id=${queryParams.get('id')}`).then(r => {
            setOrderDetail(r.data);
            getRestaurantDetail(r.data?.restaurant_info?.id)
            console.log(r.data, 'ppp')
            if (r.data.order_status == 1) {
                timeRef.current = setInterval(() => {
                    setTime(getCountdownMinutesSeconds(r.data.created_at))
                    // 时间倒计时结束后，清除定时器 刷新订单详情
                    // if (getCountdownMinutesSeconds(r.data.created_at) == '00:00') {
                    //     getOrderDetail();
                    //     clearInterval(timeRef.current)
                    //     timeRef.current = null
                    // }

                }, 1000);
            }
        })
    }
    useEffect(() => {
        getOrderDetail();
        return (() => {
            clearInterval(timeRef.current)
            timeRef.current = null
        })
    }, [])
    const sureCancel = () => {
        request.post('restaurant/reservation_order_cancel', { id: orderDetail?.id }).then(r => {
            message.success('取消成功')
            setTimeout(() => {
                getOrderDetail()
            }, 500)
        })
    }
    const sureDel = () => {
        request.post('restaurant/reservation_order_delete', { id: orderDetail?.id }).then(r => {
            message.success('删除成功')
            setTimeout(() => {
                navigate(-1)
            }, 500)
        })
    }
    const sureRefound = () => {
        request.post('restaurant/reservation_order_refund_deposit', { id: orderDetail?.id }).then(r => {
            message.success('取消预约成功')
            setTimeout(() => {
                getOrderDetail()
            }, 500)
        })
    }
    const cancelRefundDeposit = () => {
        request.post('restaurant/reservation_order_cancel_refund_deposit', { id: orderDetail?.id }).then(r => {
            message.success('取消预约已撤回')
            setTimeout(() => {
                getOrderDetail()
            }, 500)
        })
    }

    const [modalCancel, contextHolderCancel] = Modal.useModal();
    const confirmCancel = () => {
        modalCancel.confirm({
            title: '取消预约',
            icon: <ExclamationCircleOutlined />,
            content: '您确定要取消预约吗',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureCancel()
            },
            maskClosable: true,
        });
    };
    const [delCancel, contextHolderDel] = Modal.useModal();
    const confirmDel = () => {
        delCancel.confirm({
            title: '删除订单',
            icon: <ExclamationCircleOutlined />,
            content: '您确定要删除吗',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureDel()
            },
            maskClosable: true,
        });
    };
    const [refoundCancel, contextHolderRefound] = Modal.useModal();
    const confirmRefound = () => {
        refoundCancel.confirm({
            title: '取消预约',
            icon: <ExclamationCircleOutlined />,
            content: '餐厅已预约成功，取消预约将无法退预约费，您确定取消吗？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureRefound()
            },
            maskClosable: true,
        });
    };
    const submitPay = () => {
        navigate('/pay?id=' + orderDetail.id + '&sn=' + orderDetail.reservation_code + '&from=orderDetail&type=0')
    }
    return (
        <div className="order">
            <div className="order-detail-content">
                <Button type="cancel" style={{ with: "74px", height: "32px", color: "#999999", borderRadius: "4px" }}
                    onClick={() => navigate(-1)}>
                    返回
                </Button>
                {
                    orderDetail?.order_status === ORDER_STATUS.waitPay
                    && <div className="order-status">{ORDER_STATUS_NAME[orderDetail?.order_status]}</div>
                }
                {
                    orderDetail?.order_status === ORDER_STATUS.waitPay
                    && <div className="pay-time">剩余支付时间
                        <span style={{ marginLeft: '10px' }}>{time}</span>
                    </div>
                }
                {
                    // 预约确认中
                    orderDetail.order_status == ORDER_STATUS.tobeUsed && orderDetail.appointment_status == APPOINTMENT_STATUS.confirming &&
                    orderDetail.payment_status == PAYMENT_STATUS.paid &&
                    <>
                        <div className="order-status">{APPOINTMENT_STATUS_NAME[orderDetail.appointment_status]?.name}</div>
                        <div className="statusTips">{APPOINTMENT_STATUS_NAME[orderDetail.appointment_status].tip}</div>
                    </>
                }
                {
                    orderDetail.order_status == ORDER_STATUS.tobeUsed && orderDetail.appointment_status == APPOINTMENT_STATUS.success &&
                    orderDetail.payment_status == PAYMENT_STATUS.paid &&
                    <>
                        {
                            // 预约之后 申请退款
                            (orderDetail.refund_deposit_status == REFOUND_DEPOSIT_STATUS.refunding || orderDetail.refund_deposit_status == REFOUND_DEPOSIT_STATUS.fail) ? <>
                                <div className="order-status">{REFOUND_DEPOSIT_STATUS_NAME[orderDetail.refund_deposit_status]?.name}</div>
                                <div className="statusTips01">{orderDetail?.refund_remark || REFOUND_DEPOSIT_STATUS_NAME[orderDetail.refund_deposit_status].tip}</div></> :
                                <>
                                    <div className="order-status">{APPOINTMENT_STATUS_NAME[orderDetail?.appointment_status].name}</div>
                                    <div className="statusTips">{orderDetail?.refund_remark || APPOINTMENT_STATUS_NAME[orderDetail?.appointment_status].tip}</div>
                                </>
                        }
                    </>
                }
                {
                    orderDetail?.order_status === ORDER_STATUS.notTransacted && orderDetail?.appointment_status !== APPOINTMENT_STATUS.fail &&
                    orderDetail?.refund_deposit_status !== REFOUND_DEPOSIT_STATUS.success &&
                    <div className="order-status">{APPOINTMENT_STATUS_NAME[orderDetail?.appointment_status].name}</div>
                }
                {
                    orderDetail?.order_status === ORDER_STATUS.notTransacted && orderDetail?.appointment_status == APPOINTMENT_STATUS.fail &&
                    orderDetail.payment_status == PAYMENT_STATUS.unpaid &&
                    <>
                        <div className="order-status">预约已取消</div>
                        <div className="statusTips">您已取消预约， 如需预约餐厅请重新下单</div>
                    </>
                }
                {
                    orderDetail?.order_status === ORDER_STATUS.notTransacted && orderDetail?.appointment_status == APPOINTMENT_STATUS.fail &&
                    orderDetail.payment_status == PAYMENT_STATUS.fail &&
                    <>
                        <div className="order-status">预约已取消</div>
                        <div className="statusTips">订单已超时， 如需预约餐厅请重新下单</div>
                    </>
                }
                {
                    // 未成交 预约成功之后 押金退款成功
                    orderDetail?.order_status === ORDER_STATUS.notTransacted &&
                    orderDetail.payment_status == PAYMENT_STATUS.paid &&
                    <>
                        {
                            orderDetail.refund_deposit_status == REFOUND_DEPOSIT_STATUS.success && <>
                                <div className="order-status">{REFOUND_DEPOSIT_STATUS_NAME[orderDetail.refund_deposit_status].name}</div>
                                <div className="statusTips01">{orderDetail?.refund_remark || REFOUND_DEPOSIT_STATUS_NAME[orderDetail.refund_deposit_status].tip}</div>
                            </>
                        }
                    </>
                }
                {
                    // 未成交 预约失败 退全款
                    orderDetail?.order_status === ORDER_STATUS.notTransacted && orderDetail?.appointment_status == APPOINTMENT_STATUS.fail &&
                    <>
                        <div className="order-status">{REFOUND_AMOUNT_STATUS_NAME[orderDetail?.refund_amount_status]?.name}</div>
                        <div className="statusTips">{orderDetail?.refund_remark || REFOUND_AMOUNT_STATUS_NAME[orderDetail?.refund_amount_status]?.tip}</div>
                    </>
                }
                {
                    // 已完成
                    orderDetail?.order_status === ORDER_STATUS.completed &&
                    <>
                        {
                            orderDetail?.sub_status === 9 ? <>
                                <div className="order-status">订单已结束</div>
                                <div className="statusTips">{orderDetail?.refund_remark || '订单已结束'}</div></>
                                : <>
                                    <div className="order-status">{REFOUND_DEPOSIT_STATUS_NAME[orderDetail?.refund_deposit_status]?.name}</div>
                                    <div className="statusTips01">{orderDetail?.refund_remark || REFOUND_DEPOSIT_STATUS_NAME[orderDetail?.refund_deposit_status]?.tip}</div></>
                        }

                    </>

                }
                <div className="sub-time">
                    <div className="sub-name">{orderDetail?.restaurant_info?.name}</div>
                    <div className="sub-info">
                        {
                            // orderDetail.order_status == ORDER_STATUS.tobeUsed &&
                            orderDetail.appointment_status == APPOINTMENT_STATUS.success &&
                            <div className="sub-item" >
                                <div className="label">预约成功时间：</div>
                                <div>{orderDetail?.reservation_date_confirm} {orderDetail?.reservation_time_confirm}，{orderDetail?.reservation_number_confirm}人 （包含儿童）</div>
                            </div>
                        }
                        <div className="sub-item" >
                            <div className="label">预约时间：</div>
                            <div>  <div>{formatTimestampToDate(orderDetail?.reservation_date)} {orderDetail?.reservation_time}，{orderDetail?.reservation_number}人 （包含儿童）</div></div>
                        </div>
                        {
                            !!orderDetail?.adjust && !!orderDetail?.b1_reservation_date &&
                            <div className="sub-item" >
                                <div className="label">备选时间一：</div>
                                <div>{formatTimestampToDate(orderDetail?.b1_reservation_date)} {orderDetail?.b1_reservation_time}，{orderDetail?.b1_reservation_number}人</div>
                            </div>
                        }
                        {

                            !!orderDetail?.adjust && !!orderDetail?.b2_reservation_date &&
                            <div className="sub-item" >
                                <div className="label">备选时间二：</div>
                                <div>{formatTimestampToDate(orderDetail?.b2_reservation_date)} {orderDetail?.b2_reservation_time}，{orderDetail?.b2_reservation_number}人</div>
                            </div>
                        }
                        {
                            orderDetail?.seat && <div className="sub-item" >
                                <div className="label">座位类型：</div>
                                <div>{orderDetail?.seat}</div>
                            </div>
                        }
                        <div className="sub-item" >
                            <div className="label">预约套餐：</div>
                            <div>{orderDetail?.meal?.name}</div>
                        </div>
                    </div>
                </div>
                <div className="sub-time">
                    <div className="sub-name">预约者信息</div>
                    <div className="sub-info">
                        <div className="sub-item" >
                            <div className="label">姓名：</div>
                            <div>{orderDetail?.last_name + ' ' + orderDetail?.first_name}</div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">手机号码：</div>
                            <div>+{orderDetail?.area_code?.replace('+', '')} {orderDetail?.phone_number}</div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">邮箱：</div>
                            <div>{orderDetail?.email}</div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">是否有忌口：</div>
                            <div>{orderDetail?.is_dietary_restrictions ? orderDetail?.dietary_restrictions : '否'}
                            </div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">携带儿童：</div>
                            <div>{
                                orderDetail?.children_config !== '' ? (() => {
                                    const children = orderDetail && orderDetail.children_config
                                        ? (typeof orderDetail.children_config === 'string'
                                            ? JSON.parse(orderDetail.children_config)
                                            : orderDetail.children_config)
                                        : [];
                                    console.log(children, 'children')
                                    return children.length + '儿童 (' + children.map((v) => { return v + '岁' }).join(', ') + ')';
                                })() : '无'}
                            </div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">注意事项：</div>
                            <div>{orderDetail?.precautions}</div>
                        </div>
                    </div>
                </div>
                <div className="sub-time">
                    <div className="sub-name">预约费用</div>
                    <div className="sub-info">
                        <div className="sub-item" >
                            <div className="label">预约费：</div>
                            <div>￥{info?.subscription_price} x{orderDetail?.reservation_number}</div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">套餐押金：</div>
                            <div style={{ flex: 'none' }}>￥{((orderDetail?.meal_deposit) / orderDetail?.reservation_number).toFixed(2)} x{orderDetail?.reservation_number}</div>
                            <div style={{ color: '#ea0025' }}>（押金不抵扣餐费，用餐后点击“就餐完成”，上传账单小票退款）</div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">总计：</div>
                            <div>￥{(orderDetail?.reservation_total_amount * 1).toFixed(2)}</div>
                        </div>

                    </div>
                </div>
                <div className="sub-tip">
                    <div className="sub-tip-tit">预约金额说明:</div>
                    <div className="sub-tip-desc" dangerouslySetInnerHTML={{ __html: info?.subscription_price_remark }}>

                    </div>
                </div>
                <div className="sub-time">
                    <div className="sub-name">取消费率说明</div>
                    <div className="sub-info">
                        {
                            info?.cancellation_rate_desc?.map(v => {
                                return <div className="sub-item" ><div className="label">{v.day}天内取消：</div><div >{v.rate}%</div></div>
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="order-tool">
                {
                    orderDetail?.order_status === ORDER_STATUS.waitPay &&
                    <div className="order-tool-content">
                        <div className="order-tool-amount">需付款：￥{orderDetail?.reservation_total_amount * 1}</div>
                        <div className="order-btns">
                            <div className="order-btns-gray" onClick={confirmCancel}>取消预约</div>
                            {contextHolderCancel}
                            <div className="order-btns-active"
                                onClick={() => submitPay()}>立即支付</div>
                        </div>
                    </div>
                }
                {
                    // 取消预约订单
                    ((orderDetail?.order_status === ORDER_STATUS.notTransacted && orderDetail?.appointment_status == APPOINTMENT_STATUS.fail)
                        || (orderDetail?.order_status === ORDER_STATUS.completed && orderDetail?.refund_deposit_status == REFOUND_DEPOSIT_STATUS.success) ||
                        (orderDetail?.order_status === ORDER_STATUS.notTransacted && orderDetail?.refund_deposit_status == REFOUND_DEPOSIT_STATUS.success) ||
                        (orderDetail?.order_status === ORDER_STATUS.notTransacted && orderDetail?.refund_amount_status == REFOUND_AMOUNT_STATUS.success))
                    &&
                    <div className="order-tool-content">
                        {/* 删除 */}
                        <div></div>
                        <div className="order-btns">
                            <div className="order-btns-gray" onClick={confirmDel}>删除订单</div>
                            {contextHolderDel}
                        </div>
                    </div>
                }
                {
                    orderDetail.order_status == ORDER_STATUS.tobeUsed && orderDetail.appointment_status == APPOINTMENT_STATUS.success &&
                    orderDetail.payment_status == PAYMENT_STATUS.paid &&
                    <div className="order-tool-content">
                        {/* 预约成功 */}
                        <div></div>

                        <div className="order-btns">
                            {
                                [0, 2, 3, 5].includes(orderDetail.refund_deposit_status) && <div className="order-btns-gray" onClick={() => {
                                    setOpenCertificate(true)
                                }}>预约凭证</div>
                            }
                            {
                                orderDetail.refund_deposit_status == REFOUND_DEPOSIT_STATUS.init && <div className="order-btns-gray" onClick={confirmRefound}>取消预约</div>
                            }
                            {contextHolderRefound}
                            {
                                orderDetail.refund_deposit_status == REFOUND_DEPOSIT_STATUS.refunding &&
                                <div className="order-btns-gray" onClick={cancelRefundDeposit}>撤回取消</div>
                            }
                            {
                                [0, 2, 3, 5].includes(orderDetail.refund_deposit_status) && <div className="order-btns-active" onClick={() => {
                                    navigate(`/diningCompleted?id=${orderDetail?.id}&type=1`,)
                                }}>就餐完成</div>
                            }
                        </div>
                    </div>
                }
            </div>
            <Modal
                title="预约凭证"
                open={openCertificate}
                footer={null}
                onCancel={() => { setOpenCertificate(false) }}
            >
                <div className="certificate">
                    <div className="info">
                        <img mode="aspectFill" className="cover" src={Config.imgPrefix + orderDetail?.restaurant_info?.cover[0]} />
                        <div className="desc">
                            <div className="title">{orderDetail?.restaurant_info?.name}</div>
                            <div className="seat">座位预约</div>
                            <div className="node">餐费请在店内支付</div>
                        </div>

                    </div>
                    <div className="tips">
                        <div className="tips-item">
                            <div className="label">お名前：</div>
                            <div>{orderDetail?.jp_first_name}</div>
                        </div>
                        <div className="tips-item">
                            <div className="label">来店日時：</div>
                            <div>{orderDetail?.reservation_date_confirm} {orderDetail?.reservation_time_confirm}</div>
                        </div>
                        <div className="tips-item">
                            <div className="label">来店人数：</div>
                            <div>{orderDetail?.reservation_number_confirm}人</div>
                        </div>
                        <div className="tips-item">
                            <div className="label">予約番号：</div>
                            <div>{orderDetail?.merchant_order_sn}</div>
                        </div>
                        <div className="tips-item">
                            <div className="label">予約者情報：</div>
                            <div>{orderDetail?.jp_mobile}</div>
                        </div>
                        <div className="tips-item">
                            <div className="label">アレルギー：</div>
                            <div>{orderDetail?.jp_dietary_restrictions ? orderDetail?.jp_dietary_restrictions : '無し'}</div>
                        </div>
                    </div>
                </div>
            </Modal>

        </div>

    );

}

